import { useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import DateErrorIcon from "../../../assets/Date_Error_Icon.svg";
import dateIcon from "../../../assets/dateIcon.svg";
import { Calendar, Popover } from "antd";

interface INotifyEffExpDateProps {
  date: string;
  displayEditOpt: boolean;
  errorMessage: string;
  field: string;
  validStartDateToEdit: Dayjs | null;
  onEditDated: (date: Dayjs | null) => void;
  isValidDate: boolean;
  onValidCheck: (valid: boolean) => void;
}

export const NotifyEffExpDate = (props: INotifyEffExpDateProps) => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);

  useEffect(() => {
    if (props.validStartDateToEdit?.toDate) {
      const currentDate = new Date(props.validStartDateToEdit.toString());
      const expiration = new Date(props.date);

      currentDate.setHours(0, 0, 0, 0);
      expiration.setHours(0, 0, 0, 0);
      const lIsExpired = expiration < currentDate;
      props.onValidCheck(lIsExpired);
    } else {
      props.onValidCheck(true);
    }
  }, [props.validStartDateToEdit, props.date]);

  const handleDateChange = (date: Dayjs | null): void => {
    props.onEditDated(date);
    setIsPopoverVisible(false);
  };

  const content = (
    <div style={styles.datePopupcontainer}>
      <Calendar
        fullscreen={false}
        onChange={handleDateChange}
        className="date-model"
        defaultValue={dayjs(props.date)}
        validRange={[dayjs(props.validStartDateToEdit), dayjs("2049/12/31")]}
      />
    </div>
  );

  return (
    <div>
      <div className="view-modal-value-element" style={{ marginTop: "4px" }}>
        {dayjs(props.date).format("YYYY/MM/DD")}
        {props.isValidDate && (
          <img
            src={DateErrorIcon}
            alt="Error-Icon"
            style={{ marginLeft: "3px" }}
          />
        )}

        {props.displayEditOpt && (
          <Popover
            //placement=""
            content={content}
            trigger="click"
            open={isPopoverVisible}
            onOpenChange={(visible) => setIsPopoverVisible(visible)}
          >
            <span style={{ marginLeft: "10px", cursor: "pointer" }}>
              <img src={dateIcon} alt="date-icon" />
            </span>
          </Popover>
        )}
      </div>
      {props.isValidDate && (
        <div
          className="label-element"
          style={{ color: "#ad0303", width: "150px", marginTop: "5px" }}
        >
          {props.errorMessage}
        </div>
      )}
    </div>
  );
};

// Styles using standard CSS-in-JS approach
const styles = {
  datePopupcontainer: {
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    width: 300,
    height: 250,
    overflow: "auto",
  },
};
